module.exports = __webpack_public_path__ + "img/電気回路_3_1_1.6efed38b.png";